import './style.scss'

import React, { JSX } from 'react'

import { ButtonColor } from '~/components/buttons'
import { GOOGLE_EVENTS, sendGoogleGoal } from '~/libs/analytic/ga'

type Props = {
    openModal: () => void
}

export const SectionGetStarted = ({ openModal }: Props): JSX.Element => {
    const handleSubmit = (eventName: GOOGLE_EVENTS) => {
        sendGoogleGoal(eventName)

        openModal()
    }

    return (
        <div className="section-started">
            <div className="section-started__container">
                <h2 className="section-started__title">Ready to find your next cargo charter?</h2>
                <div className="section-started__text">Join 50+ verified operators and 300+ freight forwarders. Free. Verified. Commission-free.</div>
                <div className="section-started__buttons">
                    <ButtonColor
                        modClass="request-button"
                        text="Submit request"
                        onClick={() => handleSubmit(GOOGLE_EVENTS.submit_request_bottom)}
                    />
                    <ButtonColor
                        modClass="add-aircraft-button"
                        text="Add your aircraft"
                        onClick={() => handleSubmit(GOOGLE_EVENTS.add_aircraft_bottom)}
                    />
                </div>
            </div>
        </div>
    )
}
